import React from 'react';
import { InputNumber } from 'antd';
import { CssSize, NamePath } from '@xbcb/ui-types';
import { StyledFormItem } from './styles';

interface PercentInputProps {
  localNamePath: NamePath;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: (value: number | undefined) => void;
  step?: number;
  $itemSize?: CssSize | string;
  label?: React.ReactNode;
  precision?: number;
  required?: boolean;
  currency?: string;
  debounce?: boolean;
  min?: number;
  onClick?: () => void;
  onBlur?: () => void;
}

const PercentInput: React.FC<PercentInputProps> = ({
  $itemSize = CssSize.LARGE,
  label,
  disabled,
  readOnly,
  onChange,
  precision = 2,
  required = false,
  debounce = false,
  onClick,
  onBlur,
  localNamePath,
}: PercentInputProps) => {
  return (
    <div>
      <StyledFormItem
        label={label}
        name={localNamePath}
        rules={[{ required, message: ' ' }]}
        $itemSize={$itemSize}
        $readOnly={readOnly}
        $inline
        debounce={debounce}
      >
        <InputNumber
          disabled={disabled}
          readOnly={readOnly}
          required={required}
          onClick={onClick}
          onBlur={onBlur}
          onChange={(val) => {
            if (onChange) {
              onChange(val === null ? undefined : val);
            }
          }}
          max={100}
          min={0}
          precision={precision}
          addonAfter="%"
        />
      </StyledFormItem>
    </div>
  );
};

export default PercentInput;
